export default "__VITE_ASSET__D4Dg$TUd__"